export default __webpack_public_path__ + "static/media/icon-tableau-blanc.3ede3970.svg";